export default __webpack_public_path__ + "static/media/arrow-forward.932b93dd.png";